import { CreditCardListModule } from '@/components/modules/CreditCard/List/CreditCardList';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { ALL_CORE_APP_ROLES, ALL_CORE_APP_USER_TYPES } from '@/config/config';
import { ApplicationType, PageScheme } from '@/config/types';

export const PAGE_CREDIT_CARD_LIST: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.CREDIT_CARD_LIST,
  showIfAllowedProduct: ApplicationType.CARD,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: 'CREDIT_CARD_LIST',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <CreditCardListModule
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
          }}
        />
      ),
    },
  ],
};
